/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import {
  IArchivedPolicyProps,
} from "./components";

const is = require("is_js");

const SERVICE_NAME = "ArchivePolicyPageService";
const log: any = LoggerModule.getInstance();

export type IGetPageContentArgs =
IArchivedPolicyProps;

export class ArchivePolicyPageService {
  private static instance: ArchivePolicyPageService;
  private vapp: VApplication;
  private criteria: any;
  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): ArchivePolicyPageService {
    if (!ArchivePolicyPageService.instance) {
      ArchivePolicyPageService.instance = new ArchivePolicyPageService(props);
    }
    return ArchivePolicyPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = [...this.criteria, ...data];
  }

  public resetCriteria() {
    this.criteria = [];
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent(
    args: IGetPageContentArgs
  ) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.where) {
      this.setCriteria(args?.where);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getPolicyListsProps({
      ...args,
      where: [...args?.where, ...this.criteria],
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }
}
